import { Injectable, Injector } from '@angular/core';
import { Utilities } from '@shared/utilities/utilities.model';
import { ClaimItemModel, ERejectionType, RespWorkingDissociable, WorkingModel } from '../models/working.model';
import { CommodityModel } from '@shared/models/commodity.model';
import { ConstantsService } from './constants.service';
import { WorkingHistoryModel } from '../models/working-history.model';
import { FileModel } from '../models/enums.model';
import { AttachmentsService } from './attachments.service';
import { InnerMessageAuthorityMessageCode } from './inner-message-authority-utilities';
import { CommonMessageCode, MessageComponentType, MessageDetail, MessageType } from '@shared/service/message-manager/message.model';
import { MessageManagerUtilities } from '@shared/service/message-manager/message-manager-utilities';
import { AuthorityBaseService } from './authority-base.service';
import { RepairWorkingModel } from '../models/repair-working.model';
import { FormItemsModel } from '../models/form-items.model';
import { PracticeModel } from '../models/practice-model';
import { DeclineBody } from './quotation.service';
import { DossierModel } from '../models/dossier.model';
import { Observable, Subscriber } from 'rxjs';
import { UserV3Model } from '@shared/models/user-v-3.model';
import { PermissionService } from '@shared/service/permission.service';
import { NemoModuleKeys, UserPermissionsModel } from '@shared/models/user-permission.model';
import { SelectCommoditiesService } from '@shared/service/select-commodities.service';
import { ErrorResponse } from '@shared/models/error-response.model';
import { HTTPStatusCode } from '@shared/models/http-status-code.model';
import { AuthorityUtilities } from '@authority/authority-shared/utilities/authority-utilities';
import { DossierHistoryModel } from '../models/dossier-history.model';
import { TranslateContext, TranslatePipe } from '@app/shared/pipes/translate.pipe';

@Injectable()
export class WorkingsService extends AuthorityBaseService {
	prefix: string;
	isSuperUser: boolean;
	isCenterOperator: boolean;
	baseURL: string;
	user: UserPermissionsModel;
	
	// get isSuperUser(): boolean {
	// 	return this.user.isCenterSuperUserOperator2();
	// }

	// get isCenterOperator(): boolean {
	// 	return this.user.isCenterOperator2();
	// }
	workingClusterSelect: any; // Attualmente valorizzato in AuOperationWorkingDetailComponent

	constructor(
		protected injector: Injector,
		private constantsService: ConstantsService,
		private attachmentsService: AttachmentsService,
		private permissionService: PermissionService,
		private selectCommoditiesService: SelectCommoditiesService,
		private translatePipe: TranslatePipe,
	) {
		super(injector);
		this.prefix = constantsService.getPrefix();
		this.baseURL = this.environment.AUTHORITY + this.prefix;
		this.user = this.permissionService.getCurrentUserPermissions();

		// NB: essendo condiviso tra Authority e Mobility
		// potrebbe dare valori discordanti nel caso in cui uno è centro e l'altro no
		// forse è meglio metterli separati
		this.isSuperUser = this.user.isCenterSuperUserOperator2();
		this.isCenterOperator = this.user.isCenterOperator2();
	}
	
	getCommodities(): string[] {
		return this.selectCommoditiesService.getCurrentCommodities().map(commodity => commodity.id);
	}
	
	// getBaseURL(dossier?: DossierModel | DossierHistoryModel): string {
	// 	return dossier && dossier.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
	// }
	getBaseURL(x?: boolean | DossierModel | DossierHistoryModel): string {

		if (Utilities.isEmpty(x) || x === false) {
			return this.environment.api.authority.v1;
		}

		if (x == true) {
			return this.environment.api.authority.historical.v1;
		}
		
		if (x instanceof DossierModel || x instanceof DossierHistoryModel) {
			return x && x.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		}
		
		return this.environment.api.authority.v1;
	}

	getWorkingByDossierId(
		// dossierId: string, 
		dossier: DossierModel, 
		onSuccess: (workingList: WorkingModel[]) => void, 
		onFailure: (errorMessage: MessageDetail) => void, 
		commodities?: CommodityModel[]
	): void {
		
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossier_id + '/workings';
		const url = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings';

		// con Mobility le commodities in input devono essere ignorate
		// è sempre stato inutile passarle come input
		// codice ridondante, andava messo direttament nella funzione...
		// const arrayCommodities: string[] = [];
		// commodities.forEach((commodity) => {
		// 	arrayCommodities.push(commodity.id);
		// });
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						// const workingList: WorkingsList = new WorkingsList(response.json());
						onSuccess( response.json().workings.map(x => new WorkingModel(x)) );
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getWorkingById(
		dossierId: string, 
		workingId: string, 
		isArchived: boolean, 
		onSuccess: (working: WorkingModel) => void, 
		onFailure: (errorMessage: MessageDetail) => void,
		onComplete?: () => void
	): void {
		// const url: string = this.baseURL + '/dossiers/' + dossierId + '/workings/' + workingId;
		const url: string = this.getBaseURL(isArchived) + '/dossiers/' + dossierId + '/workings/' + workingId;
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					try {
						const workingModel: WorkingModel = new WorkingModel(response.json());
						onSuccess(workingModel);
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: InnerMessageAuthorityMessageCode.AUTHORITY_GENERIC_SERVICE_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			},
			() => onComplete ? onComplete() : null
		);
	}

	massiveClosure(
		dossiers: DossierModel[],
		onSuccess: (successMessage: MessageDetail) => void,
		onFailure: (errorMessage: MessageDetail) => void
		): void{

		const url: string = this.environment.AUTHORITY + '/dossiers/massive-closure';
		let dossiersId: string[] = [];
		dossiers.forEach(dossier => {
			dossiersId.push(dossier.id);
		});
		const requestBody: any = {
			ids: dossiersId,
		};
		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					const responseModel: any = response.json();
					onSuccess({
						code: responseModel.all_dossiers_massively_closed ? InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_MASSIVE_CLOSURE : InnerMessageAuthorityMessageCode.AUTHORITY_PARTIAL_SUCCESS_MASSIVE_CLOSURE,
						type: responseModel.all_dossiers_massively_closed ? MessageType.TYPE_SUCCESS : MessageType.TYPE_WARNING,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
		
	}

	startWorking(
		dossier: DossierModel, 
		workingId: string, 
		quotationId: string, 
		commodities: CommodityModel[],
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossierId + '/workings/' + workingId + '/quotations/' + quotationId + '/working_start';
		const url: string = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + workingId + '/quotations/' + quotationId + '/working_start';
		const arrayCommodities: string[] = [];
		commodities.forEach((commodity) => {
			arrayCommodities.push(commodity.id);
		});
		const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		this.httpAuthService.patch(url, {}, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_START_WORKING,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	stopWorking(
		dossier: DossierModel, 
		working_id: string, 
		quotation_id: string, 
		commodities: CommodityModel[],
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' + quotation_id + '/working_end';
		const url: string = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings/' + working_id + '/quotations/' + quotation_id + '/working_end';
		const arrayCommodities: string[] = [];
		commodities.forEach((commodity) => {
			arrayCommodities.push(commodity.id);
		});
		const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		this.httpAuthService.patch(url, {}, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_END_WORKING,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	deleteWorking(
		dossier: DossierModel,
		workingId: string, 
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + this.prefix + '/dossiers/' + dossier_id + '/workings/' + workingId;
		const url = this.getBaseURL(dossier) + '/dossiers/' + dossier.id + '/workings/' + workingId;
		this.httpAuthService.delete(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					onSuccess({
						type: MessageType.TYPE_SUCCESS,
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_REMOVE_WORKING,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	createWorking(
		body: WorkingModel, 
		// dossier_id: string, 
		dossier: DossierModel, 		
		commodities: CommodityModel[], 
		edit: boolean, 
		onSuccess: (successMessage: MessageDetail) => void,
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url = this.getBaseURL(dossier) + '/dossiers/' + dossier.id + '/workings/' + workingId;
		let url: string = this.getBaseURL(dossier) + this.prefix + '/dossiers/' + dossier.id + '/workings';
		if (edit) {
			url = url + '/' + body.id;
		}
		const arrayCommodities: string[] = [];
		commodities.forEach((commodity) => {
			arrayCommodities.push(commodity.id);
		});
		const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);

		const claimsList: ClaimItemModel[] = [];
		let obj: any = null;
		if (body.claimsList && body.claimsList.length > 0) {
			for (let i: number = 0; i < body.claimsList.length; i++) {
				obj = {};
				obj.claim_id = body.claimsList[i].claim_id;
				obj.franchise_number = Number(body.claimsList[i].franchise_number) || 0;
				obj.practice_id = body.claimsList[i].practice_id;
				if (obj.claim_id) {
					claimsList.push(obj);
				}
			}
		}
		if (claimsList && claimsList.length > 0) {
			body.claimsList = claimsList;
		}

		const repairsList: RepairWorkingModel[] = [];
		let rep: any = null;
		if (body.repairsList && body.repairsList.length > 0) {
			for (let i: number = 0; i < body.repairsList.length; i++) {
				rep = {};
				rep.id = body.repairsList[i].id;
				rep.practice_id = body.repairsList[i].practice_id;
				if (rep.id) {
					repairsList.push(rep);
				}
			}
		}
		if (repairsList && repairsList.length > 0) {
			body.repairsList = repairsList;
		}

		const practicesList: PracticeModel[] = [];
		let pra: any = null;
		if (body.practicesList && body.practicesList.length > 0) {
			for (let i: number = 0; i < body.practicesList.length; i++) {
				pra = {};
				pra.id = body.practicesList[i].id;
				pra.practice_id = body.practicesList[i].practice_id;
				pra.practice_type = body.practicesList[i].processing_types;
				if (pra.id) {
					practicesList.push(pra);
				}
			}
		}
		if (practicesList && practicesList.length > 0) {
			body.practicesList = practicesList;
		}

		let working: any = {};
		if (body && body.isRepair) {
			working = {
				causal_type: body.causalType,
				commodity_rule_id: body.rulesId,
				//claims_list: body.claimsList,
				repairs_list: body.repairsList,
				type: body.type,
				working_items: body.workingItems
			};
		} else if (body && body.isPractices) {
			working = {
				causal_type: body.causalType,
				commodity_rule_id: body.rulesId,
				//claims_list: body.claimsList,
				car_practice_list: body.practicesList,
				type: body.type,
				working_items: body.workingItems
			};
		} else {
			working = {
				causal_type: body.causalType,
				claims_list: body.claimsList,
				type: body.type,
				working_items: body.workingItems
			};
		}

		if (!edit) {
			this.httpAuthService.post(url, working, this.redirectUrl, options).subscribe(
				response => {
					if (response.ok) {
						onSuccess({
							type: MessageType.TYPE_SUCCESS,
							code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_CREATE_WORKING,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					} else {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				}
			);
		} else {
			this.httpAuthService.put(url, working, this.redirectUrl, options).subscribe(
				response => {
					if (response.ok) {
						onSuccess({
							type: MessageType.TYPE_SUCCESS,
							code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_WORKING,
							componentType: MessageComponentType.SNACK_BAR
						});
					} else {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				}
			);
		}
	}

	arrived(
		dossier: DossierModel,
		workingId: string, 
		quotationId: string, 
		entryIds: string[],
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/quotations/${quotationId}/entries/arrived`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/quotations/${quotationId}/entries/arrived`;
		
		const requestBody: ArrivedRequestBody = {
			entries_id: entryIds,
		};

		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_PARTS_ARRIVED,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getHistoryWorking(
		dossier: DossierHistoryModel,
		isConsultation: boolean, 
		onSuccess: (response: WorkingHistoryModel) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${isConsultation ? 'consultation' : 'history'}`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${isConsultation ? 'consultation' : 'history'}`;
		
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					try {
						// @ts-ignore
						const responseBody: any = JSON.parse(response._body);
						onSuccess(new WorkingHistoryModel(responseBody));
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	addAttachments(
		dossier: DossierModel,
		workingId: string,
		commodities: CommodityModel[],
		files: FileModel[],
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/attachments`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/attachments`;
		this.attachmentsService.addAttachments(url, commodities, files, onSuccess, onFailure, [{
			key: 'thumbnail',
			value: 'true'
		}]);
	}

	removeAttachments(
		dossier: DossierModel,
		workingId: string,
		commodities: CommodityModel[],
		attachmentIds: string[],
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/attachments`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/attachments`;
		this.attachmentsService.removeAttachments(url, commodities, attachmentIds, onSuccess, onFailure, [{
			key: 'ids',
			value: attachmentIds.toString()
		}]);
	}

	channelAction(workingIds: string[], onSuccess: (successMessage: MessageDetail) => void, onFailure: (errorMessage: MessageDetail) => void): void {
		const url: string = `${this.environment.AUTHORITY}/workings/channel`;

		const requestBody: ChannelRequestBody = {
			ids: workingIds
		};
		this.httpAuthService.post(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_CHANNELLING,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getVehicleRules(commodityId: string, type: string, onSuccess: (response: any) => void, onFailure: (errorMessage: MessageDetail) => void): void {
		const url: string = `${this.environment.AUTHORITY}/commodities/${commodityId}/vehicle_rules?vehicle_type=${type}`;
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					try {
						// @ts-ignore
						const responseBody: any = JSON.parse(response._body);
						onSuccess(responseBody);
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	populateFields(
		dossier: DossierModel,
		workingId: string, 
		onSuccess: (response: any) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		//const url: string = `${this.environment.AUTHORITY}/commodities/${dossierId}/workings/${workingId}/administrative_practices`;
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/administrative_practices`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/administrative_practices`;
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					try {
						// @ts-ignore
						const responseBody: any = response.json();
						onSuccess(responseBody);
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);

		/**const responseBody: any ='{"re_registration":{"rear_plate_status":"DETERIORATED","front_plate_status":"LOST","is_plate_installed":true,' +
	'"expected_delivery_date":"2019-11-28 10:03:19","ald_material_receipt_date":"2019-11-29 10:03:19  ",'+
	'"customer_id":"105815","fiscal_code":null,"fleet_manager_id":null,"plate_customer_id":"105815",'+
	'"user_session_token":"5oqa3e32g99d3utsj5nltu24n7"}}';
	onSuccess(JSON.parse(responseBody));*/
	}

	sendPractice(
		item: FormItemsModel, 
		dossier: DossierModel,
		workingId: string,
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/administrative_practices/${item.id}/send_fleet_manager`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/administrative_practices/${item.id}/send_fleet_manager`;
		let requestBody: any = null;

		requestBody = {
			working_id: workingId,
			id: item.id,

			re_registration: {
				rear_plate_status: item.rearPlateStatus,
				front_plate_status: item.frontPlateStatus,
				is_plate_installed: item.isPlateInstalled,
				vehicle_registration: item.vehicle_registration,
				expected_delivery_date: item.expectedDeliveryDate,
				ald_material_receipt_date: item.aldMaterialReceiptDate
			},
			re_punching: {
				chassis: item.chassis,
				processing_at: item.processingAt,
				processing_date: item.processingDate,
				processing_center_address: item.processingCenterAddress
			},
		};

		const r: string = JSON.stringify(requestBody.re_registration);
		if (r === '{}') {
			requestBody.re_registration = null;
		}

		const p: string = JSON.stringify(requestBody.re_punching);
		if (p === '{}') {
			requestBody.re_punching = null;
		}

		if (r !== '{}' && !item.rearPlateStatus && !item.frontPlateStatus && item.vehicle_registration === null && item.isPlateInstalled === null && !item.expectedDeliveryDate &&
			!item.aldMaterialReceiptDate) {
			requestBody.re_registration = {
				rear_plate_status: null,
				front_plate_status: null,
				is_plate_installed: null,
				vehicle_registration: null,
				expected_delivery_date: null,
				ald_material_receipt_date: null
			};
		}

		if (p !== '{}' && !item.chassis && !item.processingAt && !item.processingCenterAddress && !item.processingDate) {
			requestBody.re_punching = {
				chassis: null,
				processing_at: null,
				processing_date: null,
				processing_center_address: null
			};
		}

		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_SEND_PRACTICE_TO_FLEET,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	sendPracticeToCenter(
		item: FormItemsModel, 
		dossier: DossierModel,
		workingId: string,
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/administrative_practices/${item.id}/send_assistance_center`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/administrative_practices/${item.id}/send_assistance_center`;

		let requestBody: any = null;

		requestBody = {
			working_id: workingId,
			id: item.id,

			re_registration: {
				rear_plate_status: item.rearPlateStatus,
				front_plate_status: item.frontPlateStatus,
				is_plate_installed: item.isPlateInstalled,
				vehicle_registration: item.vehicle_registration,
				expected_delivery_date: item.expectedDeliveryDate,
				ald_material_receipt_date: item.aldMaterialReceiptDate
			},
			re_punching: {
				chassis: item.chassis,
				processing_at: item.processingAt,
				processing_date: item.processingDate,
				processing_center_address: item.processingCenterAddress
			},
		};

		const r: string = JSON.stringify(requestBody.re_registration);
		if (r === '{}') {
			requestBody.re_registration = null;
		}

		const p: string = JSON.stringify(requestBody.re_punching);
		if (p === '{}') {
			requestBody.re_punching = null;
		}

		if (r !== '{}' && !item.rearPlateStatus && !item.frontPlateStatus && item.vehicle_registration === null && item.isPlateInstalled === null && !item.expectedDeliveryDate &&
			!item.aldMaterialReceiptDate) {
			requestBody.re_registration = {
				rear_plate_status: null,
				front_plate_status: null,
				is_plate_installed: null,
				vehicle_registration: null,
				expected_delivery_date: null,
				ald_material_receipt_date: null
			};
		}

		if (p !== '{}' && !item.chassis && !item.processingAt && !item.processingCenterAddress && !item.processingDate) {
			requestBody.re_punching = {
				chassis: null,
				processing_at: null,
				processing_date: null,
				processing_center_address: null
			};
		}

		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_SEND_PRACTICE_TO_CA,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	stopAdminWorking(
		item: FormItemsModel, 
		dossier: DossierModel,
		workingId: string,
		onSuccess: (successMessage: MessageDetail) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/administrative_practices/${item.id}/administrative_practice_working_end`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/administrative_practices/${item.id}/administrative_practice_working_end`;

		let requestBody: any = null;

		requestBody = {
			working_id: workingId,
			id: item.id,

			re_registration: {
				rear_plate_status: item.rearPlateStatus,
				front_plate_status: item.frontPlateStatus,
				is_plate_installed: item.isPlateInstalled,
				vehicle_registration: item.vehicle_registration,
				expected_delivery_date: item.expectedDeliveryDate,
				ald_material_receipt_date: item.aldMaterialReceiptDate
			},
			re_punching: {
				chassis: item.chassis,
				processing_at: item.processingAt,
				processing_date: item.processingDate,
				processing_center_address: item.processingCenterAddress
			},
		};

		const r: string = JSON.stringify(requestBody.re_registration);
		if (r === '{}') {
			requestBody.re_registration = null;
		}

		const p: string = JSON.stringify(requestBody.re_punching);
		if (p === '{}') {
			requestBody.re_punching = null;
		}

		if (r !== '{}' && !item.rearPlateStatus && !item.frontPlateStatus && item.vehicle_registration === null && item.isPlateInstalled === null && !item.expectedDeliveryDate &&
			!item.aldMaterialReceiptDate) {
			requestBody.re_registration = {
				rear_plate_status: null,
				front_plate_status: null,
				is_plate_installed: null,
				vehicle_registration: null,
				expected_delivery_date: null,
				ald_material_receipt_date: null
			};
		}

		if (p !== '{}' && !item.chassis && !item.processingAt && !item.processingCenterAddress && !item.processingDate) {
			requestBody.re_punching = {
				chassis: null,
				processing_at: null,
				processing_date: null,
				processing_center_address: null
			};
		}

		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_STOP_WORK,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	rejectPractice(
		item: FormItemsModel, 
		dossier: DossierModel,
		workingId: string, 
		onSuccess: (message: MessageDetail) => void, 
		onFailure: (message: MessageDetail) => void, 
		declineBody?: DeclineBody
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/administrative_practices/${item.id}/administrative_practice_reject`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/workings/${workingId}/administrative_practices/${item.id}/administrative_practice_reject`;

		const requestBody: any = {

			declined_note: declineBody.declined_note
		};
		this.httpAuthService.patch(url, requestBody, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS__REJECTED,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getWorkingsDashboard(): Observable<any> {		
		let url: string = `${this.environment.AUTHORITY}/workings/dashboard`;
		const arrayCommodities: string[] = (this.isSuperUser || this.isCenterOperator) ? this.getCommodities() : []; 
		const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		return new Observable<any>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
					response => {
						const content = response.json();
						if (!response.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}
	
	getWorkingDissasociable(workingId: string, rejectionType: ERejectionType): Observable<RespWorkingDissociable | ErrorResponse> {
		const url: string = `${this.environment.AUTHORITY}/claims/${workingId}/dissociable?rejection_type=${rejectionType}`;
		return new Observable<RespWorkingDissociable | ErrorResponse>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						
						try {

							if (res.ok) {
								observer.next(new RespWorkingDissociable(res.json()));
								return;
							}
							
							observer.next(new ErrorResponse(res.json()));

						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						observer.error(err);
					});
			});
	}

	deleteWorkingDissasociable(workingId: string, rejectionType: ERejectionType): Observable<any | ErrorResponse> {
		let url: string = `${this.environment.AUTHORITY}/claims/${workingId}/dissociable?rejection_type=${rejectionType}`;
		return new Observable<any | ErrorResponse>(
			observer => {
				this.httpAuthService.delete(url, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						
						try {
							
							if (res.ok) {
								observer.next(res.json());
								return;
							}
							
							observer.next(new ErrorResponse(res.json()));

						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						observer.error(err);
					});
			});
	}
	
	handlerRESTcall<T>(observer: Subscriber<T>, type?: {new(args: any): T}, onSuccessFn?: Function, onFailFn?: Function, onCompleteFn?: Function): THandlerRestCallResp {
		const successHandler = (observer: Subscriber<T>, res: Response): void => {
			if (res.status === HTTPStatusCode[200]) {
				try {
					console.log(res)
					const defaultFn = (): T|T[] => (Array.isArray(res) ? res.map(x => new type(x)) : new type(res));
					observer.next(onSuccessFn ? onSuccessFn() : defaultFn());
				} catch (err) {
					console.error(err);
					observer.error(err);
				}
			} else {
				const err = new ErrorResponse(res);
				if (err.hasStatusCode([HTTPStatusCode[404], HTTPStatusCode[500]])) {
					console.error(err);
					observer.error(err);
				}	
				observer.next(null);
			}
		};
		const failHandler = (observer: Subscriber<T>, err: any): void => {
			onFailFn ? onFailFn() : null;
			console.error(err);
			observer.error(err);
		};
		const completeHandler = (err: any): void => {
			onCompleteFn ? onCompleteFn() : null;
		};

		// return [ successHandler, failHandler, completeHandler ];
		return {
			[EHandlerType.SUCCESS]	: successHandler, 
			[EHandlerType.FAIL]		  : failHandler, 
			[EHandlerType.COMPLETE] : completeHandler,
		};
	}

	// Non in uso
	getWorking(workingId: string): Observable<WorkingModel> {
		const url: string = this.baseURL + '/workings/' + workingId;
		return new Observable<WorkingModel>(
			observer => {
				const handler = this.handlerRESTcall<WorkingModel>(observer, WorkingModel);
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
					res => handler[EHandlerType.SUCCESS],
					err => handler[EHandlerType.FAIL],
				);
		});
	}

	getWorkingsClusters(onSuccess: (response: any) => void, onFailure: (errorMessage: MessageDetail) => void): void {
		const url: string = `${this.environment.AUTHORITY}/workings/clusters`;
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				if (response.ok) {
					try {
						const responseBody: any = response.json();
						onSuccess(responseBody);
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						componentType: MessageComponentType.FLASH_MESSAGE,
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.EMPTY_MESSAGE,
							message: this.translatePipe.transform('ERR__RICEZIONE_CLUSTER', TranslateContext.AUTHORITY)
					});
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	patchWorkingsClusters(workingId: string, body: any, onSuccess: (message: MessageDetail) => void, onFailure: (message: MessageDetail) => void, declineBody?: DeclineBody): void {
		const url: string = `${this.environment.AUTHORITY}/workings/${workingId}/clusters`;
		this.httpAuthService.patch(url, body, this.redirectUrl).subscribe(
			(response) => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.GENERIC_SUCCESS,
						type: MessageType.TYPE_SUCCESS,
						componentType: MessageComponentType.SNACK_BAR
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}
}

interface ChannelRequestBody {
	ids: string[];
}

interface ArrivedRequestBody {
	entries_id: string[];
}


type THandlerRestCallResp = {
	success?	: Function,
	fail?		  : Function,
	complete? : Function,
}

enum EHandlerType {
	SUCCESS	 = 'success',
	FAIL	   = 'fail',
	COMPLETE = 'complete',	
}